import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d192494")

_pushScopeId("data-v-0d192494")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-d-flex p-flex-column" }
const _hoisted_4 = { class: "p-mb-4 p-text-bold" }
const _hoisted_5 = { class: "p-d-flex p-ml-4 select-button" }
const _hoisted_6 = { class: "p-mr-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-file" }, null, -1)
const _hoisted_8 = { class: "p-mr-6 p-mb-8" }
const _hoisted_9 = { class: "p-col-12" }
const _hoisted_10 = { class: "card shadow-box" }
const _hoisted_11 = { class: "p-grid" }
const _hoisted_12 = { class: "p-d-flex p-flex-column" }
const _hoisted_13 = { class: "p-mb-2 p-text-light" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_15 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_16 = { class: "p-pl-2" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "p-d-flex p-ai-center" }
const _hoisted_19 = { class: "p-pl-2" }
const _hoisted_20 = {
  key: 0,
  class: "p-col"
}
const _hoisted_21 = { class: "p-d-flex p-flex-column" }
const _hoisted_22 = { class: "p-mb-2 p-text-light" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_24 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_25 = { class: "p-pl-2" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "p-d-flex p-ai-center" }
const _hoisted_28 = { class: "p-pl-2" }
const _hoisted_29 = {
  key: 1,
  class: "p-col"
}
const _hoisted_30 = { class: "p-d-flex p-flex-column" }
const _hoisted_31 = { class: "p-mb-2 p-text-light" }
const _hoisted_32 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_33 = { class: "p-pl-2" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "p-d-flex p-ai-center" }
const _hoisted_36 = { class: "p-pl-2" }
const _hoisted_37 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_38 = { class: "p-d-flex p-flex-column" }
const _hoisted_39 = { class: "p-mb-4" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "p-grid" }
const _hoisted_42 = { class: "p-col" }
const _hoisted_43 = { class: "p-col" }
const _hoisted_44 = { class: "p-grid" }
const _hoisted_45 = { class: "p-col" }
const _hoisted_46 = { class: "p-field-radiobutton" }
const _hoisted_47 = { class: "p-col" }
const _hoisted_48 = { class: "p-d-flex p-flex-column" }
const _hoisted_49 = { class: "p-grid" }
const _hoisted_50 = { class: "p-col" }
const _hoisted_51 = { class: "p-grid" }
const _hoisted_52 = { class: "p-col" }
const _hoisted_53 = { class: "p-field-radiobutton" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  key: 0,
  class: "p-d-flex p-flex-column p-jc-center p-ai-center",
  style: {"min-height":"40vh"}
}
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "p-d-flex p-jc-between" }
const _hoisted_58 = { class: "\n              p-datatable p-component p-datatable-striped\n              overflow-table\n              three-columns\n            " }
const _hoisted_59 = { class: "p-datatable-wrapper" }
const _hoisted_60 = {
  class: "p-datatable-table",
  role: "table"
}
const _hoisted_61 = {
  class: "p-datatable-thead",
  role: "rowgroup"
}
const _hoisted_62 = { role: "row" }
const _hoisted_63 = /*#__PURE__*/_createVNode("th", { role: "cell" }, null, -1)
const _hoisted_64 = { role: "cell" }
const _hoisted_65 = { class: "p-column-header-content" }
const _hoisted_66 = { role: "cell" }
const _hoisted_67 = { class: "p-column-header-content" }
const _hoisted_68 = {
  class: "p-datatable-tbody",
  role: "rowgroup"
}
const _hoisted_69 = { role: "row" }
const _hoisted_70 = { role: "cell" }
const _hoisted_71 = { role: "cell" }
const _hoisted_72 = { role: "cell" }
const _hoisted_73 = { role: "row" }
const _hoisted_74 = { role: "cell" }
const _hoisted_75 = { role: "cell" }
const _hoisted_76 = { role: "cell" }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = {
  key: 0,
  class: "p-d-flex p-flex-column p-jc-center p-ai-center",
  style: {"min-height":"40vh"}
}
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "p-datatable p-component p-datatable-striped overflow-table" }
const _hoisted_81 = { class: "p-datatable-wrapper" }
const _hoisted_82 = {
  class: "p-datatable-table",
  role: "table"
}
const _hoisted_83 = {
  class: "p-datatable-thead",
  role: "rowgroup"
}
const _hoisted_84 = { role: "row" }
const _hoisted_85 = /*#__PURE__*/_createVNode("th", { role: "cell" }, null, -1)
const _hoisted_86 = { role: "cell" }
const _hoisted_87 = { class: "p-column-header-content" }
const _hoisted_88 = {
  class: "p-datatable-tbody",
  role: "rowgroup"
}
const _hoisted_89 = { role: "row" }
const _hoisted_90 = {
  role: "cell",
  class: "rowhead-cell"
}
const _hoisted_91 = {
  role: "cell",
  class: "compact-cell p-ai-center p-d-flex"
}
const _hoisted_92 = { class: "p-col-3 p-pt-1 p-pb-1 p-pl-0 p-pr-2" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_94 = { class: "p-col-3 p-pt-1 p-pb-1 p-pl-2 p-pr-2" }
const _hoisted_95 = {
  key: 0,
  class: "p-error p-ml-2"
}
const _hoisted_96 = { role: "row" }
const _hoisted_97 = {
  role: "cell",
  class: "rowhead-cell"
}
const _hoisted_98 = {
  role: "cell",
  class: "compact-cell p-ai-center p-d-flex"
}
const _hoisted_99 = { class: "p-col-3 p-pt-1 p-pb-1 p-pl-0 p-pr-2" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_101 = { class: "p-col-3 p-pt-1 p-pb-1 p-pl-2 p-pr-2" }
const _hoisted_102 = {
  key: 0,
  class: "p-error p-ml-2"
}
const _hoisted_103 = {
  key: 1,
  class: "p-col-12"
}
const _hoisted_104 = { class: "p-d-flex p-flex-column" }
const _hoisted_105 = { class: "p-mb-4" }
const _hoisted_106 = { class: "p-grid" }
const _hoisted_107 = { class: "p-col-4" }
const _hoisted_108 = { class: "p-mb-3" }
const _hoisted_109 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_110 = { class: "p-col-8" }
const _hoisted_111 = { class: "p-mb-3" }
const _hoisted_112 = { class: "p-d-flex" }
const _hoisted_113 = {
  key: 2,
  class: "p-col-12 p-mb-6"
}
const _hoisted_114 = { class: "p-d-flex p-jc-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_PredictionType = _resolveComponent("PredictionType")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_AdvancedSetting = _resolveComponent("AdvancedSetting")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("autots.create.label.ds.name")), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.datasourceName), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "datasource-detail",
              to: `/workspace/${_ctx.workspaceId}/datasource/${_ctx.id}`,
              target: "_blank"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("datasource.metadata.link.details")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(_component_Button, {
            type: "Button",
            label: _ctx.$t('datasource.metadata.link.change.datasource'),
            class: "p-button-link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectDatasource()))
          }, null, 8, ["label"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", {
            class: {
              'p-col': _ctx.getDateColumn.length > 0,
              'p-col-4': _ctx.getDateColumn.length == 0,
            }
          }, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.$t("automl.create.header.predicttarget")), 1),
                _hoisted_14
              ]),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedTargetColumn,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTargetColumn = $event)),
                options: _ctx.getTargetColumn,
                optionLabel: "name",
                filter: true,
                placeholder: _ctx.$t('automl.create.header.Select'),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeTargetColumn($event))),
                showClear: _ctx.showClearTarget,
                class: ["dropdown-width", {
                  'p-invalid': _ctx.selectedTargetColumn.name === '',
                }]
              }, {
                value: _withId((slotProps) => [
                  (slotProps.value.name)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode(_component_DataType, {
                          dataType: slotProps.value.type
                        }, null, 8, ["dataType"]),
                        _createVNode("div", _hoisted_16, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withId((slotProps) => [
                  _createVNode("div", _hoisted_18, [
                    _createVNode(_component_DataType, {
                      dataType: slotProps.option.type
                    }, null, 8, ["dataType"]),
                    _createVNode("div", _hoisted_19, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "placeholder", "showClear", "class"])
            ])
          ], 2),
          (_ctx.selectedTargetColumn && _ctx.selectedTargetColumn.name !== '')
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t("automl.create.header.prediction.type")), 1),
                    _hoisted_23
                  ]),
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.selectedPredictionType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedPredictionType = $event)),
                    options: _ctx.predictionTypeList,
                    optionLabel: "label",
                    placeholder: 
                  _ctx.loadingCandidatesTarget
                    ? _ctx.$t('automl.create.prediction.determining')
                    : _ctx.$t('automl.create.header.Select')
                ,
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangePredictionType($event))),
                    loading: _ctx.loadingCandidatesTarget,
                    class: ["dropdown-width", {
                  'p-invalid': _ctx.selectedPredictionType.key === '',
                }]
                  }, {
                    value: _withId((slotProps) => [
                      (slotProps.value.key)
                        ? (_openBlock(), _createBlock("div", _hoisted_24, [
                            _createVNode(_component_PredictionType, {
                              dataType: slotProps.value.key
                            }, null, 8, ["dataType"]),
                            _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t(slotProps.value.label)), 1)
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withId((slotProps) => [
                      _createVNode("div", _hoisted_27, [
                        _createVNode(_component_DataType, {
                          dataType: slotProps.option.key
                        }, null, 8, ["dataType"]),
                        _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder", "loading", "class"])
                ])
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.selectedTargetColumn &&
              _ctx.selectedTargetColumn.name !== '' &&
              _ctx.getDateColumn.length > 0
            )
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("automl.create.header.datecolumn")), 1),
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.selectedDateColumn,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedDateColumn = $event)),
                    options: _ctx.getDateColumn,
                    optionLabel: "name",
                    filter: true,
                    placeholder: _ctx.$t('automl.create.header.Select'),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeDateColumn($event))),
                    showClear: _ctx.showClearTimeSeries,
                    class: "dropdown-width"
                  }, {
                    value: _withId((slotProps) => [
                      (slotProps.value.name)
                        ? (_openBlock(), _createBlock("div", _hoisted_32, [
                            _createVNode(_component_DataType, {
                              dataType: slotProps.value.type
                            }, null, 8, ["dataType"]),
                            _createVNode("div", _hoisted_33, _toDisplayString(slotProps.value.name), 1)
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withId((slotProps) => [
                      _createVNode("div", _hoisted_35, [
                        _createVNode(_component_DataType, {
                          dataType: slotProps.option.type
                        }, null, 8, ["dataType"]),
                        _createVNode("div", _hoisted_36, _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder", "showClear"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (!_ctx.loadingCandidatesTarget && _ctx.selectedTargetColumn.name != '')
      ? (_openBlock(), _createBlock("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _createVNode("strong", _hoisted_39, _toDisplayString(_ctx.$t("automl.create.label.config.infor")), 1),
            (
            _ctx.selectedPredictionType.key === 'regression' &&
            _ctx.selectedDateColumn.name != ''
          )
              ? (_openBlock(), _createBlock("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _createVNode("div", _hoisted_42, [
                      _createVNode("h6", null, _toDisplayString(_ctx.$t("automl.create.timeseries.label")), 1)
                    ]),
                    _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("autots.create.header.IDCs")), 1)
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, [
                      _createVNode("div", _hoisted_46, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeseriesOptionList, (item) => {
                          return (_openBlock(), _createBlock("div", {
                            key: item.key,
                            style: {"margin-right":"10rem"}
                          }, [
                            _createVNode(_component_RadioButton, {
                              id: item.key,
                              name: "selectedTimeseriesOption",
                              value: item,
                              modelValue: _ctx.selectedTimeseriesOption,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedTimeseriesOption = $event)),
                              class: "p-mr-2"
                            }, null, 8, ["id", "value", "modelValue"]),
                            _createVNode("label", {
                              for: item.key
                            }, _toDisplayString(_ctx.$t(item.label)), 9, ["for"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, [
                        _createVNode(_component_MultiSelect, {
                          modelValue: _ctx.selectedIDCs,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedIDCs = $event)),
                          options: _ctx.getIdcs,
                          optionLabel: "name",
                          placeholder: _ctx.$t('autots.create.select'),
                          class: "multiselect-custom",
                          display: "chip",
                          disabled: _ctx.isDisableIDCs
                        }, null, 8, ["modelValue", "options", "placeholder", "disabled"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_49, [
              _createVNode("div", _hoisted_50, [
                _createVNode("h6", null, _toDisplayString(_ctx.$t("automl.create.header.train.test")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trainTestSplits, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      key: item.key
                    }, [
                      (
                    !(
                      (_ctx.isTimeSeries(item.key) &&
                        _ctx.selectedDateColumn.name === '') ||
                      (_ctx.selectedTimeseriesOption &&
                        _ctx.selectedTimeseriesOption.key === 'yes' &&
                        !_ctx.isTimeSeries(item.key))
                    )
                  )
                        ? (_openBlock(), _createBlock(_component_RadioButton, {
                            key: 0,
                            id: item.key,
                            name: "selectedTrainTestSplit",
                            value: item,
                            modelValue: _ctx.selectedTrainTestSplit,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedTrainTestSplit = $event)),
                            class: "p-mr-2"
                          }, null, 8, ["id", "value", "modelValue"]))
                        : _createCommentVNode("", true),
                      (
                    !_ctx.isTimeSeries(item.key) &&
                    !(
                      _ctx.selectedTimeseriesOption &&
                      _ctx.selectedTimeseriesOption.key === 'yes'
                    )
                  )
                        ? (_openBlock(), _createBlock("label", {
                            key: 1,
                            for: item.key,
                            style: {"margin-right":"10rem"}
                          }, _toDisplayString(_ctx.$t(item.label)), 9, ["for"]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.isTimeSeries(item.key) && _ctx.selectedDateColumn.name !== ''
                  )
                        ? (_openBlock(), _createBlock("label", {
                            key: 2,
                            for: item.key,
                            style: {"margin-right":"10rem"}
                          }, _toDisplayString(_ctx.$t(item.label) + "(" + _ctx.selectedDateColumn.name + ")"), 9, ["for"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          (_ctx.isRandom(_ctx.selectedTrainTestSplit.key))
            ? (_openBlock(), _createBlock("div", _hoisted_54, [
                (_ctx.loadingDatasourceProfile)
                  ? (_openBlock(), _createBlock("div", _hoisted_55, [
                      _createVNode(_component_ProgressSpinner),
                      _createVNode("h5", null, _toDisplayString(_ctx.$t("datasource.eda.analyzing.title")), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.$t("datasource.eda.analyzing.description")), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_56, [
                      _createVNode("div", _hoisted_57, [
                        _createVNode("div", {
                          style: 
                'text-align: center; min-width: 10%; white-space: nowrap; width: ' +
                _ctx.trainPercentage +
                '%'
              
                        }, [
                          _createVNode("label", null, _toDisplayString(_ctx.$t("automl.create.header.train")), 1)
                        ], 4),
                        _createVNode("div", {
                          style: 
                'text-align: center; min-width: 10%; white-space: nowrap; width: ' +
                (100 - _ctx.trainPercentage) +
                '%'
              
                        }, [
                          _createVNode("label", null, _toDisplayString(_ctx.$t("automl.create.header.test")), 1)
                        ], 4)
                      ]),
                      _createVNode(_component_Slider, {
                        class: "p-mb-4",
                        modelValue: _ctx.trainPercentage,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.trainPercentage = $event)),
                        min: "1",
                        max: "99"
                      }, null, 8, ["modelValue"]),
                      _createVNode("div", _hoisted_58, [
                        _createVNode("div", _hoisted_59, [
                          _createVNode("table", _hoisted_60, [
                            _createVNode("thead", _hoisted_61, [
                              _createVNode("tr", _hoisted_62, [
                                _hoisted_63,
                                _createVNode("th", _hoisted_64, [
                                  _createVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("automl.create.header.percent")), 1)
                                ]),
                                _createVNode("th", _hoisted_66, [
                                  _createVNode("div", _hoisted_67, _toDisplayString(_ctx.$t("automl.create.header.data")), 1)
                                ])
                              ])
                            ]),
                            _createVNode("tbody", _hoisted_68, [
                              _createVNode("tr", _hoisted_69, [
                                _createVNode("td", _hoisted_70, _toDisplayString(_ctx.$t("automl.create.header.train")), 1),
                                _createVNode("td", _hoisted_71, _toDisplayString(_ctx.trainPercentage), 1),
                                _createVNode("td", _hoisted_72, _toDisplayString(_ctx.datasourceProfile?.table.n
                          ? Math.round(
                              (_ctx.datasourceProfile?.table.n * _ctx.trainPercentage) /
                                100
                            )
                          : _ctx.$t("automl.prediction.board.nodata")), 1)
                              ]),
                              _createVNode("tr", _hoisted_73, [
                                _createVNode("td", _hoisted_74, _toDisplayString(_ctx.$t("automl.create.header.test")), 1),
                                _createVNode("td", _hoisted_75, _toDisplayString(100 - _ctx.trainPercentage), 1),
                                _createVNode("td", _hoisted_76, _toDisplayString(_ctx.datasourceProfile?.table.n
                          ? _ctx.datasourceProfile?.table.n -
                            Math.round(
                              (_ctx.datasourceProfile?.table.n * _ctx.trainPercentage) /
                                100
                            )
                          : _ctx.$t("automl.prediction.board.nodata")), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isTimeSeries(_ctx.selectedTrainTestSplit.key))
            ? (_openBlock(), _createBlock("div", _hoisted_77, [
                (_ctx.loadingCandidatesTimeSeries)
                  ? (_openBlock(), _createBlock("div", _hoisted_78, [
                      _createVNode(_component_ProgressSpinner),
                      _createVNode("h5", null, _toDisplayString(_ctx.$t("datasource.eda.analyzing.title")), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.$t("datasource.eda.analyzing.description")), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_79, [
                      _createVNode("div", _hoisted_80, [
                        _createVNode("div", _hoisted_81, [
                          _createVNode("table", _hoisted_82, [
                            _createVNode("thead", _hoisted_83, [
                              _createVNode("tr", _hoisted_84, [
                                _hoisted_85,
                                _createVNode("th", _hoisted_86, [
                                  _createVNode("div", _hoisted_87, _toDisplayString(_ctx.$t("automl.create.header.duration")), 1)
                                ])
                              ])
                            ]),
                            _createVNode("tbody", _hoisted_88, [
                              _createVNode("tr", _hoisted_89, [
                                _createVNode("td", _hoisted_90, _toDisplayString(_ctx.$t("automl.create.header.train")), 1),
                                _createVNode("td", _hoisted_91, [
                                  _createVNode("div", _hoisted_92, [
                                    _createVNode(_component_Calendar, {
                                      id: "startDate",
                                      style: {"width":"100%"},
                                      modelValue: _ctx.trainDateFrom,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.trainDateFrom = $event)),
                                      dateFormat: "yy-mm-dd",
                                      minDate: _ctx.startDate,
                                      maxDate: _ctx.trainDateTo,
                                      monthNavigator: true,
                                      yearNavigator: true,
                                      yearRange: "1970:2100",
                                      manualInput: false
                                    }, null, 8, ["modelValue", "minDate", "maxDate"])
                                  ]),
                                  _hoisted_93,
                                  _createVNode("div", _hoisted_94, [
                                    _createVNode(_component_Calendar, {
                                      id: "startDate",
                                      style: {"width":"100%"},
                                      modelValue: _ctx.trainDateTo,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.trainDateTo = $event)),
                                      dateFormat: "yy-mm-dd",
                                      minDate: _ctx.trainDateFrom,
                                      maxDate: _ctx.maxOfTestDataEnd(),
                                      class: { 'p-invalid': _ctx.invalidTrainDate },
                                      monthNavigator: true,
                                      yearNavigator: true,
                                      yearRange: "1970:2100",
                                      manualInput: false
                                    }, null, 8, ["modelValue", "minDate", "maxDate", "class"])
                                  ]),
                                  (_ctx.invalidTrainDate)
                                    ? (_openBlock(), _createBlock("span", _hoisted_95, _toDisplayString(_ctx.$t("automl.create.error.trainData")), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode("tr", _hoisted_96, [
                                _createVNode("td", _hoisted_97, _toDisplayString(_ctx.$t("automl.create.header.test")), 1),
                                _createVNode("td", _hoisted_98, [
                                  _createVNode("div", _hoisted_99, [
                                    _createVNode(_component_Calendar, {
                                      id: "startDate",
                                      style: {"width":"100%"},
                                      modelValue: _ctx.testDateFrom,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.testDateFrom = $event)),
                                      dateFormat: "yy-mm-dd",
                                      minDate: _ctx.trainDateFrom,
                                      maxDate: _ctx.testDateTo,
                                      class: { 'p-invalid': _ctx.invalidTestDate },
                                      monthNavigator: true,
                                      yearNavigator: true,
                                      yearRange: "1970:2100",
                                      manualInput: false
                                    }, null, 8, ["modelValue", "minDate", "maxDate", "class"])
                                  ]),
                                  _hoisted_100,
                                  _createVNode("div", _hoisted_101, [
                                    _createVNode(_component_Calendar, {
                                      id: "startDate",
                                      style: {"width":"100%"},
                                      modelValue: _ctx.testDateTo,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.testDateTo = $event)),
                                      dateFormat: "yy-mm-dd",
                                      minDate: _ctx.testDateFrom,
                                      maxDate: _ctx.endDate,
                                      monthNavigator: true,
                                      yearNavigator: true,
                                      yearRange: "1970:2100",
                                      manualInput: false
                                    }, null, 8, ["modelValue", "minDate", "maxDate"])
                                  ]),
                                  (_ctx.invalidTestDate)
                                    ? (_openBlock(), _createBlock("span", _hoisted_102, _toDisplayString(_ctx.$t("automl.create.error.trainData")), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loadingCandidatesTarget && _ctx.selectedPredictionType.key != '')
      ? (_openBlock(), _createBlock("div", _hoisted_103, [
          _createVNode("div", _hoisted_104, [
            _createVNode("strong", _hoisted_105, _toDisplayString(_ctx.$t("autots.create.label.config.metric")), 1)
          ]),
          _createVNode("div", _hoisted_106, [
            _createVNode("div", _hoisted_107, [
              _createVNode("div", _hoisted_108, [
                _createTextVNode(_toDisplayString(_ctx.$t("label.primary_metric")), 1),
                _hoisted_109
              ]),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedPrimaryMetric,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectedPrimaryMetric = $event)),
                options: _ctx.primaryMetricOptions,
                optionLabel: "label",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onChangeMetric($event)))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode("div", _hoisted_110, [
              _createVNode("div", _hoisted_111, _toDisplayString(_ctx.$t("label.other_metrics")), 1),
              _createVNode("div", _hoisted_112, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionalMetricOptions, (metric) => {
                  return (_openBlock(), _createBlock("div", {
                    key: metric,
                    class: "p-field-checkbox p-mr-6"
                  }, [
                    _createVNode(_component_Checkbox, {
                      id: metric.key,
                      name: "metric",
                      value: metric,
                      modelValue: _ctx.otherMetrics,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.otherMetrics = $event))
                    }, null, 8, ["id", "value", "modelValue"]),
                    _createVNode("label", {
                      for: metric.key
                    }, _toDisplayString(metric.label), 9, ["for"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_Button, {
            label: _ctx.$t('automl.create.advanced.setting'),
            class: "p-button-link p-p-0",
            onClick: _ctx.openAdvancedSetting
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_AdvancedSetting, {
            visible: _ctx.displayAdvancedSetting,
            "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => (_ctx.displayAdvancedSetting = $event)),
            opening: _ctx.displayAdvancedSetting,
            autoMlSchemas: _ctx.getRemainColumn,
            selectedAdvancedSettingRunMode: _ctx.selectedAdvancedSettingRunMode,
            selectedAdvancedSettingLimitTime: _ctx.selectedAdvancedSettingLimitTime,
            selectedAdvancedSettingColumn: _ctx.selectedAdvancedSettingColumn,
            onOnSetting: _ctx.onAdvancedSetting
          }, null, 8, ["visible", "opening", "autoMlSchemas", "selectedAdvancedSettingRunMode", "selectedAdvancedSettingLimitTime", "selectedAdvancedSettingColumn", "onOnSetting"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loadingCandidatesTarget && _ctx.selectedTargetColumn.name != '')
      ? (_openBlock(), _createBlock("div", _hoisted_113, [
          _createVNode("div", _hoisted_114, [
            _createVNode(_component_Button, {
              label: _ctx.$t('button.create.experiment.start'),
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.Complete())),
              disabled: !_ctx.isEnableCreateButton,
              loading: _ctx.processing,
              style: {"width":"100%"}
            }, null, 8, ["label", "disabled", "loading"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})